module.exports = __webpack_public_path__ + "img/noplus.08980519.png";